let dataTableContainers = document.querySelectorAll('.has-data-table');

for (let i = 0; i < dataTableContainers.length; i++) {

    let dataTableElms = dataTableContainers[i].querySelectorAll('table');

    for (let y = 0; y < dataTableElms.length; y++) {

        let dataTableElm = dataTableElms[y];

        let dataTableElmHead = dataTableElm.querySelector('thead');
        let dataTableElmHeadTds = dataTableElmHead.querySelectorAll('th');

        let dataTableColNumbers = [];
        let dataTableColTitles = [];

        for (let x = 0; x < dataTableElmHeadTds.length; x++){
            dataTableColNumbers.push(dataTableElmHeadTds[x].cellIndex);
            dataTableColTitles.push(dataTableElmHeadTds[x].textContent);
        }

        let dataTable = new simpleDatatables.DataTable(dataTableElm, {
            labels: {
                perPage: `<select class="dataTable-selector"><option value="10">Show 10 Per Page</option><option value="25">Show 25 Per Page</option><option value="50">Show 50 Per Page</option><option value="100">Show 100 Per Page</option></select>`,
            },
            nextText: `<span class="visuallyhidden">next page</span><i class="sj--icon-arrow-right"></i>`,
            prevText: `<span class="visuallyhidden">prev page</span><i class="sj--icon-arrow-left"></i>`,
            perPage: 10,
            sortable: false,
            columns: [
                {
                    select: dataTableColNumbers,
                    render: function(data, td, rowIndex, cellIndex) {
                        td.setAttribute('data-label' , dataTableColTitles[td.cellIndex]);
                        return `${data}`;
                    }
                }
            ]
        });

        dataTable.on('datatable.init', function(args) {
            this.input.parentElement.classList.add('field-group');
            this.pagers[0].classList.add('sj--pagination');
            for (let p = 0; p < this.pagers[0].children.length; p++){
                this.pagers[0].children[p].classList.add('page');
            }
            let perPageFilter = this.wrapper.querySelector('.dataTable-selector');
            let perPageFilterChoices = new Choices(perPageFilter, {searchEnabled: false});
        });

        dataTable.on('datatable.selectrow', function(row, event) {
            event.preventDefault();
            let dataTableRows = dataTableElm.querySelectorAll('tr');
            for (let x = 0; x < dataTableRows.length; x++){
                dataTableRows[x].classList.remove('selected');
            }
            if(row.classList.contains('selected')){
                row.classList.remove('selected');
            }else{
                row.classList.add('selected');
            }
        });        
        
    }
}




